var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.renderWhenActive || _vm.isActive)?_c('section',{staticClass:"tabs-panel",class:_vm.classes,attrs:{"id":_vm.computedId,"aria-hidden":!_vm.isActive,"role":"tabpanel"}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }